import { useState, useEffect, useRef } from "react";
import { getModalStyle } from '@/utils/Modal';
import { getBoxStyle } from '@/utils/Styles';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    Box
} from '@mui/material';

import Button from '@/components/Button';
import Dropdown from '@/components/Dropdown';

import {
    Close as CloseIcon,
    RemoveRedEye as ViewIcon,
    Redo as PlanInIcon,
    Undo as PlanOutIcon,
    Engineering as MaintenanceIcon,
    Book as BookingIcon
} from '@mui/icons-material';

import { date } from '@/utils/Dates';
import { getPlanUrl } from '@/utils/URL';

export default function ResourceEventsModal({t, open, setOpen, fullScreen, resource, handleInfo}){

	const { sxDialog/*, sxCloseIcon*/ } = getModalStyle();
    const { sxBoxSticky } = getBoxStyle();

    const handleClose = () => {
        setOpen(false);
    }

    const [ events, setEvents ] = useState([]);
    const [ filteredEvents, setFilteredEvents ] = useState([]);

    // to scroll to top
    const eventsRef = useRef();
    /*
    const handleScroll = (elementRef) => {
        
        if(elementRef.current){
            elementRef.current.scrollIntoView({
                //top: '0px',
                behavior: 'smooth',
            });
        }
    };
    */

    useEffect(() => {
        
        if(open && resource){

            const newResource = resource;            

            var newEvents = [];

            if(newResource?.events && newResource?.events?.length > 0){

                const eventsExtraInfo = newResource?.events?.map((event) => {

                    return {
                        ...event,                        
                        plan_url: getPlanUrl(event?.plan)
                    };
                });

                newEvents = [...newEvents,...eventsExtraInfo];                        
            }
            
            setEvents(newEvents);
            setFilteredEvents(newEvents);
            setStatus(statuses[0]?.id);
        }
        else{
            setEvents([]);
            setFilteredEvents([]);
            setStatus(statuses[0]?.id);
        }

    },[open]);

    // fo filter by status
    const [ status, setStatus ] = useState(null);
    //const [ statuses ] = useState(['all','rental','booking','maintenance']);
    const [ statuses ] = useState([
        {id:'all', name: t('resource_rentals.events.statuses.all')},
        {id:'rental', name: t('resource_rentals.events.statuses.rental')},
        {id:'booking', name: t('resource_rentals.events.statuses.booking')},
        {id:'maintenance', name: t('resource_rentals.events.statuses.maintenance')}
    ]);

    const handleStatus = (newStatus) => {
        
        setStatus(newStatus);

        // filter events
        filterEvents(newStatus);
    }

    // to filter events
    const filterEvents = (statusInfo) => {

        const newFilteredEvents = [];
        events && events?.length > 0 && events?.forEach((item) => {

            if(              
                !statusInfo ||
                statusInfo === 'all' ||
                (statusInfo === 'rental' && (item?.status?.type === 'planin' || item?.status?.type === 'planout')) ||
                (statusInfo === 'booking' && (item?.status?.type === 'bookingin' || item?.status?.type === 'bookingout')) ||
                (statusInfo === 'maintenance' && (item?.status?.type === 'maintenancein' || item?.status?.type === 'maintenanceout'))
            ){
                newFilteredEvents.push(item);
            }
            
        });

        setFilteredEvents(newFilteredEvents);
        //handleScroll(eventsRef);

    }

    return (
        
        <Dialog
            container={fullScreen?.active ? fullScreen?.node?.current : null}
            sx={sxDialog}
            onClose={handleClose}
            open={open}
            fullWidth={true}            
        >                        
        	<DialogTitle className='modal-title'>
                {resource?.name}
            </DialogTitle>            
            <DialogContent className='modal-content text-center'>
                {/*<div className='font-bold mb-2'>{t('resource_rentals.history.title')}</div>*/}
                {
                    statuses && statuses?.length > 0 &&
                    <Box sx={sxBoxSticky}>
                        {/*
                        <div className="noprint flex w-full mb-4 max-md:grid max-md:grid-cols-12 items-center justify-center pb-2">
                            
                                statuses?.map((stat) => (
                                    <div 
                                        key={'resource_rentals_status_'+stat}
                                        className="mx-1 max-md:ml-0 max-md:my-1 max-md:col-span-12 max-md:text-center flex justify-center items-center"
                                    >
                                        <Button                     
                                            onClick={() => 
                                                (stat === status || (stat === 'all' && !status)) ?
                                                    null
                                                :
                                                    handleStatus(stat)
                                            }
                                            type={(stat === status || (stat === 'all' && !status)) ? 'app' : 'appoutlined'}
                                            text={t('resource_rentals.events.statuses.'+stat)}
                                        />                                        
                                    </div>                    
                                ))                                                        
                        </div>  
                        */}
                        <div className='w-full pb-2'>
                            <Dropdown                                                    
                                name='status'                                
                                value={status}                                                                
                                options={statuses}
                                handleDropdown={handleStatus}                                
                                noempty
                            />
                        </div>
                    </Box>
                }
                <div ref={eventsRef}> 
                {
                    filteredEvents?.map((event) => (
                        <div   
                            key={'resource_rental_event_'+event?.id}
                            className='border rounded p-2 mb-4'
                        >
                            <div className='resource-rental-event-title'>
                                {t('resource_rentals.history.fields.type')}
                            </div>                            
                            <div className='resource-rental-event-content'>
                                {
                                    event?.status?.type && event?.status?.type?.length > 0 ?
                                        <>
                                        <div className='me-1'>
                                            {
                                                event.status.type === 'planin'?
                                                    <PlanInIcon color='error'/>
                                                :
                                                    event.status.type === 'planout' ?
                                                        <PlanOutIcon color='success'/>
                                                    :
                                                        event.status.type === 'maintenancein' ?
                                                            <MaintenanceIcon color='error'/>
                                                        :
                                                            event.status.type === 'maintenanceout' ?
                                                                <MaintenanceIcon color='success'/>
                                                            :
                                                                event.status.type === 'bookingin' ?
                                                                    <BookingIcon color='success'/>
                                                                :
                                                                    event.status.type === 'bookingout' ?
                                                                        <BookingIcon color='error'/>
                                                                    :
                                                                        <></>

                                            }
                                        </div>
                                        <div>
                                            {t('resource_rentals.history.type.'+event?.status?.type)}
                                        </div>
                                        </>
                                    :
                                        '-'
                                }
                            </div>
                            {
                                event?.plan?.name && event?.plan?.name?.length > 0 &&
                                <>
                                <div className='resource-rental-event-title'>
                                    {t('resource_rentals.history.fields.plan')}
                                </div>
                                <div className='resource-rental-event-content'>
                                    {
                                        event?.plan_url && event?.plan_url?.length > 0 ?
                                            <a href={event.plan_url} target='_blank'>{event?.plan?.name}</a>
                                        :
                                            event?.plan?.name
                                    }
                                </div>
                                </>
                            }
                            <div className='resource-rental-event-title'>
                                {t('resource_rentals.history.fields.date')}
                            </div>
                            <div className='resource-rental-event-content'>
                                {date(event?.date,true,true)}
                            </div>
                            <div className='resource-rental-event-title'>
                                {t('resource_rentals.history.fields.responsible')}
                            </div>
                            <div className='resource-rental-event-content'>
                                {
                                    event?.user?.name && event?.user?.name?.length > 0 ?  
                                        event?.user?.name
                                    :
                                        '-'
                                }
                            </div>
                            {
                                event?.description && event?.description?.length > 0 &&
                                <>
                                <div className='resource-rental-event-title'>
                                    {t('resource_rentals.history.fields.observations')}
                                </div>                            
                                <div className='resource-rental-event-content'>
                                    {event?.description}
                                </div>
                                </>
                            }
                            {
                                event?.files && event?.files?.length > 0 &&
                                <div className='mt-4 mb-2'>                                    
                                    <Button
                                        text={'imagenes'}
                                        type='app'
                                        onClick={() => handleInfo(event)}
                                    />
                                </div>         
                            } 
                        </div>
                    ))
                }
                </div>
            </DialogContent>            
            <div className="modal-buttons">                
                <div className=''>
                    <CloseIcon className='action-button-modal text-black' onClick={handleClose}/>
                </div>
            </div>        
        </Dialog>
  );
}